import {ILauncherServiceFactory} from '../../../launcher-service-factory.interface';
import {makeConfigurationArea} from '../make-configuration-area';
import {ROOT_CONFIGURATION_KEYS} from '../../root-configuration-keys';
import {BooleanFieldDefinition} from '../../fields-definitions/boolean-field-definition';

export function makeSegmentsConfigurationArea(services: ILauncherServiceFactory) {
    return makeConfigurationArea(ROOT_CONFIGURATION_KEYS.webDataSegments, services, {
        IsCIP: new BooleanFieldDefinition('IsCIP'),
        IsCIS: new BooleanFieldDefinition('IsCIS')
    });
}